import { FC } from 'react';
import { observer, useNavigate } from '~/modules';
import { Routes } from '~/routes';
import { useStores } from '~/utils';
import CreditSimulationInstallments from './CreditSimulationInstallments';

const CreditSimulationInstallmentsContainer: FC = () => {
  const { creditProducts } = useStores();
  const navigate = useNavigate();
  const handleInstallmentOptionSelect = (simulationPlan: SimulationPlans) => {
    creditProducts.setCurrentSimulationPlan(simulationPlan);
    navigate(Routes.CREDIT_SIMULATION_SUMMARY);
  };

  return (
    <CreditSimulationInstallments
      requestedCreditSimulationValue={
        creditProducts.requestedCreditSimulationValue
      }
      simulationPlans={creditProducts.simulationPlans}
      handleInstallmentOptionSelect={handleInstallmentOptionSelect}
    />
  );
};
export default observer(CreditSimulationInstallmentsContainer);
